import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import { useSession } from "./store/session";

import LoginPage from "./pages/Login";
import RegisterPage from "./pages/Register";
import HomePage from "./pages/Home";
import QuestsPage from "./pages/Quests";
import PartnersPage from "./pages/Partners";
import PlacesPage from "./pages/Places";
import StoriesPage from "./pages/Stories";
import MessagesPage from "./pages/Messages";
import ConsentsPage from "./pages/Consents";
import SettingsPage from "./pages/Settings";
import SupportPage from "./pages/Support";
import VerifyEmailPage from "./pages/VerifyEmail";

import CalendarPage from "./pages/Calendar";
import QuestDetailPage from "./pages/QuestDetail";
import OfflineOutboxPage from "./pages/OfflineOutbox";
import OfflineMediaOutboxPage from "./pages/OfflineMediaOutbox";
import ContextDmLauncherPage from "./pages/ContextDmLauncher";
import GroupsDiscoverablePage from "./pages/GroupsDiscoverable";
import GroupDetailPage from "./pages/GroupDetail";
import AcceptGroupInvitePage from "./pages/AcceptGroupInvite";
import GlobalMessageDelivery from "./components/GlobalMessageDelivery";


export default function App() {
  const { user, loading, bootstrap } = useSession();

  useEffect(() => {
    // bootstrap() loads current user if token exists
    bootstrap().catch(() => void 0);
  }, [bootstrap]);

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 text-slate-200 flex items-center justify-center">
        Loading…
      </div>
    );
  }

  const currentUserId = String(
    (user as any)?.id ||
    (user as any)?.userId ||
    (user as any)?.user_id ||
    ""
  );

  return (
    <>
      {user && currentUserId ? (
        <GlobalMessageDelivery
          currentUserId={currentUserId}
        />
      ) : null}

      <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/register" element={user ? <Navigate to="/" replace /> : <RegisterPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/quests" element={<QuestsPage />} />
          <Route path="/quests/:id" element={<QuestDetailPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/places" element={<PlacesPage />} />
          <Route path="/stories" element={<StoriesPage />} />
          <Route path="/messages" element={<MessagesPage />} />
          <Route path="/consents" element={<ConsentsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/offline-outbox" element={<OfflineOutboxPage />} />
          <Route path="/offline-media-outbox" element={<OfflineMediaOutboxPage />} />
          <Route path="/context-dm-launcher" element={<ContextDmLauncherPage />} />

          <Route path="/groups" element={<GroupsDiscoverablePage />} />
          <Route path="/groups/:groupId" element={<GroupDetailPage />} />
          <Route path="/group-invites/accept" element={<AcceptGroupInvitePage />} />

        </Route>
      </Route>

      <Route path="*" element={<Navigate to={user ? "/" : "/login"} replace />} />
      </Routes>
    </>
  );
}
